/** Environment detection helpers for adapting CLI UX to CI, pipes, and remote sessions. */

export function isCI(): boolean {
  return Boolean(process.env['CI']);
}

/** True when both stdin and stdout are TTYs — safe to render interactive prompts. */
export function isInteractive(): boolean {
  return Boolean(process.stdin.isTTY && process.stdout.isTTY);
}

/** True when running inside an SSH session — browser auto-open won't reach the user. */
export function isSSH(): boolean {
  return Boolean(process.env['SSH_CONNECTION'] || process.env['SSH_TTY']);
}
